/** Community explore visibility — maps to communities.is_private. */

export const COMMUNITY_PRIVACY_OPTIONS = [
  {
    id: 'public',
    title: 'Public',
    description: 'Listed in Play → Communities → Explore for your region. Required to create and host tournaments.',
  },
  {
    id: 'private',
    title: 'Private',
    description: 'Hidden from explore on mobile app. Tournaments cannot be created or hosted.',
  },
]

export const TOURNAMENT_REQUIRES_PUBLIC_COMMUNITY_TITLE = 'Public community required'

export const TOURNAMENT_REQUIRES_PUBLIC_COMMUNITY_MESSAGE =
  'Tournaments can only be created and hosted by public communities. Switch your community to public in Settings to continue.'

/** True when the community may create or host tournaments. */
export function communityCanHostTournaments(isPrivate) {
  return isPrivate !== true
}

/** Normalize draft / legacy policy shapes to is_private boolean. */
export function migrateCommunityIsPrivate(policies = {}) {
  if (typeof policies.isPrivate === 'boolean') return policies.isPrivate
  if (policies.visibility === 'private') return true
  if (policies.visibility === 'public') return false
  return false
}
